import { Alert } from './general-store.types'

export const initialAlertPayload: Alert = {
  type: 'info',
  message: '',
  counter: 0
}
